module.exports = __webpack_public_path__ + "img/check-mark.2d201256.png";